import { Alert, Spin } from 'antd';
import { getCompanyById, getRecruitmentsByCompanyId } from 'api/companySite';
import CompanySiteLayout from 'layout/CompanySiteLayout';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import About from './sections/About';
import Contact from './sections/Contact';
import Hero from './sections/Hero';
import JobList from './sections/JobList';

function CompanySitePage() {
  const { companyId } = useParams();
  const [company, setCompany] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const basePath = `/c/${companyId}`;

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!companyId) {
        setError('Company not found');
        setLoading(false);
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const [companyData, recruitmentsRes] = await Promise.all([
          getCompanyById(companyId),
          getRecruitmentsByCompanyId(companyId),
        ]);
        if (!cancelled) {
          setCompany(companyData);
          setJobs(recruitmentsRes?.data ?? []);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e?.message || 'Failed to load company');
          setCompany(null);
          setJobs([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  if (loading && !company) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8f9fa',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (error && !company) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
        }}
      >
        <Alert
          type="error"
          message="Không tải được trang"
          description={error}
          showIcon
        />
      </div>
    );
  }

  return (
    <CompanySiteLayout company={company} basePath={basePath}>
      <Hero company={company} />
      <About company={company} />
      <JobList
        jobs={jobs}
        loading={false}
        basePath={basePath}
      />
      <Contact company={company} />
    </CompanySiteLayout>
  );
}

export default CompanySitePage;
